import { memo, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import cn from 'classnames';
import { hideNumber } from '../../helpers/titreHelper';
import styles from './Message.module.css';
import { customIconsSources } from '../../helpers/icons';
import { MessageContent } from '../MessageContent/MessageContent';

const Message = ({ className, message, isFirst, setDelay }) => {
  const contentContainerRef = useRef();

  const errorHandler = (e) => {
    e.target.src = customIconsSources['livechat'];
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={`${message.id}`}
        className={cn(styles.wrapper, className)}
      >
        <div className={styles.author}>
          <motion.img
            key={`${message.id}-channel`}
            src={
              customIconsSources[message.channel] ||
              customIconsSources['livechat']
            }
            className={styles.channel}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: { duration: 0.2, delay: isFirst ? 0.4 + 0.08 : 0.08 },
            }}
            exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
            onError={errorHandler}
          />
          <motion.div
            key={`${message.id}-name`}
            className={styles.name}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.2,
                delay: isFirst ? 0.4 + 0.2 + 0.08 : 0.2 + 0.08,
              },
            }}
            exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
          >
            {message?.author || hideNumber(message?.senderNumber)}
          </motion.div>
          <motion.div
            key={`${message.id}-dots`}
            className={`${styles.dots}`}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.2,
                delay: isFirst ? 0.4 + 0.2 + 0.08 : 0.2 + 0.08,
              },
            }}
            exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
          >
            :
          </motion.div>
        </div>

        <motion.div
          key={`${message.id}-content`}
          className={styles.contentWrapper}
          ref={contentContainerRef}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              duration: 0.2,
              delay: isFirst
                ? 0.4 + 0.2 + 0.08 + 0.2 + 0.08
                : 0.2 + 0.08 + 0.2 + 0.08,
            },
          }}
          exit={{ opacity: 0, transition: { duration: 0.2, delay: 0 } }}
        >
          <MessageContent
            content={message.content}
            contentContainerRef={contentContainerRef}
            msgId={message.id}
            setDelay={setDelay}
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default memo(Message);
